import {
    Modal,
    Box,
    TextField,
    Button,
    Typography,
    IconButton
} from "@mui/material";
import { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { getMobileNumber, verifyOtpApi } from "../../services/ProposalServices";
import useUrlQuery from "../../hooks/useUrlQuery";
import { toast } from "react-toastify";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 350,
    bgcolor: "background.paper",
    p: 4,
    borderRadius: 2,
};

interface Props {
    open: boolean;
    sessionToken: string;
    onSuccess: () => void;
    onClose: () => void;
}

const OtpModal = ({ open, sessionToken, onSuccess, onClose }: Props) => {

    const { get } = useUrlQuery();
    const PROPOSAL_ID = get("proposal_id");

    const [phone, setPhone] = useState("");
    const [otp, setOtp] = useState("");
    const [timer, setTimer] = useState(120);
    const maskedPhone = phone ? `XXXXXX${phone.slice(-4)}` : "";
    // call API when modal opens
    useEffect(() => {
        if (open && PROPOSAL_ID) {
            fetchMobileNumber();
        }
    }, [open, PROPOSAL_ID]);
    const fetchMobileNumber = async () => {
        try {
            const res = await getMobileNumber(PROPOSAL_ID);

            if (res.status === 200) {
                setPhone(res.response.mobile_number);
                setOtp("");
                setTimer(120); // restart timer
            }
        } catch (error) {
            console.log(error);
        }
    };

    // countdown timer
    useEffect(() => {
        if (!open || timer === 0) return;

        const interval = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [open, timer]);

    const verifyOtp = async () => {
        if (!PROPOSAL_ID) return;

        try {
            const res = await verifyOtpApi(PROPOSAL_ID, otp);

            if (res.status === 200 && res.response?.session_token) {
                toast.success(res.message || "OTP verified successfully");

                sessionStorage.setItem("session_token", res.response.session_token);

                onSuccess();
                window.location.reload();
            } else {
                toast.error(res.message || "Invalid OTP");
            }
        } catch (error) {
            console.log("OTP verify error:", error);
            toast.error("Something went wrong while verifying OTP");
        }
    };

    return (
        <Modal
            open={open}
            onClose={(event, reason) => {
                if (reason === "backdropClick") {
                    return; // prevent closing when clicking background
                }
                onClose();
            }}
            slotProps={{
                backdrop: {
                    sx: {
                        backdropFilter: "blur(6px)",
                        backgroundColor: "rgba(0,0,0,0.25)"
                    }
                }
            }}
        >
            <Box sx={{ ...style, position: "relative" }}>

                {/* <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton> */}

                <Typography mb={1} fontWeight={600}>
                    Verify Mobile Number
                </Typography>

                <Typography mb={2} fontSize={14} color="text.secondary">
                    We have sent an OTP to the mobile number {maskedPhone} to view the proposal details.
                </Typography>
                {/* 
        <TextField
          fullWidth
          label="Mobile Number"
          value={phone}
          disabled
        /> */}

                <TextField
                    fullWidth
                    sx={{ mt: 2 }}
                    label="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                />

                {timer > 0 ? (
                    <Typography mt={1}>
                        you can resend the OTP in {timer}s
                    </Typography>
                ) : (
                    <Button
                        size="small"
                        sx={{ mt: 1 }}
                        onClick={fetchMobileNumber}
                    >
                        Retry OTP
                    </Button>
                )}

                <Button
                    fullWidth
                    sx={{ mt: 2 }}
                    variant="contained"
                    onClick={verifyOtp}
                    disabled={!otp || !timer}
                >
                    Verify OTP
                </Button>

            </Box>
        </Modal>
    );
};

export default OtpModal;